import * as React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import { AnimatedLogo } from "components/menu/AnimatedLogo";

const ModalLoading = ({
  title = "Loading User Data...",
  subtitle = "Please Wait",
}) => {

  return (
    <div
      style={{
        backdropFilter: "blur(1px)",
      }}
    >
      <Dialog height={220} width={400}>
        <div className="d-flex h-100">
          <div className="d-flex flex-column justify-content-center align-items-center w-100">
            <AnimatedLogo collapsed loop size="medium" />
            <div className="mt-3 text-center">
              <div className={`mx-auto mb-2 fs-sm mt-1`}>
                <b>{title}</b>
              </div>
              <div
                className={`mx-auto fs-sm mt-1`}
                style={{ color: "gray" }}
              >
                <b>{subtitle}</b>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default ModalLoading;
